import { useSearchParams } from 'react-router-dom'
import { useShallow } from 'zustand/shallow'

import { useStore, getNodesSelector } from '@app/store'
import type { DomainNode } from '@app/types'

type UseGetNodes = (strategyId: string) => DomainNode[]

const useGetNodes: UseGetNodes = (strategyId) => {
  const [searchParams] = useSearchParams()

  return useStore(useShallow((state) => getNodesSelector(state, strategyId, searchParams)))
}

export default useGetNodes
